import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './WhoAreYouShoppingFor.module.scss';

export type BuyingFor = 'existing' | 'new';

interface Props {
  petNames: string[];
  selected: BuyingFor | null;
  onSelect: (choice: BuyingFor) => void;
}

export default function WhoAreYouShoppingFor({ petNames, selected, onSelect }: Props) {
  const { t } = useTranslation();
  const [first, second, third] = petNames;

  let existingLabel: string;
  if (petNames.length === 1) existingLabel = first;
  else if (petNames.length === 2) existingLabel = t('existing_dog_card_two_names', { first, second });
  else if (petNames.length === 3) existingLabel = t('existing_dog_card_three_names', { first, second, third });
  else existingLabel = t('existing_dog_card_many_names', { first, second, count: petNames.length - 2 });

  return (
    <div className={styles.section}>
      <h2 className={styles.title}>{t('who_are_you_shopping_for')}</h2>
      <div className={styles.options}>
        <button
          type="button"
          className={classNames(styles.option, { [styles.selected]: selected === 'existing' })}
          onClick={() => onSelect('existing')}
          aria-pressed={selected === 'existing'}
        >
          <p className={styles.optionTitle}>{existingLabel}</p>
          <p className={styles.optionBody}>{t('existing_dog_card_subtitle', { firstPet: first })}</p>
        </button>
        <button
          type="button"
          className={classNames(styles.option, { [styles.selected]: selected === 'new' })}
          onClick={() => onSelect('new')}
          aria-pressed={selected === 'new'}
        >
          <p className={styles.optionTitle}>{t('new_dog_card_title')}</p>
          <p className={styles.optionBody}>{t('new_dog_card_subtitle')}</p>
        </button>
      </div>
    </div>
  );
}
